import React, { useEffect } from "react";
import { Typography, Button, Box } from "@mui/material";

const GlobalErrorPage = () => {
    let errorDetails = {};
    try {
        errorDetails = JSON.parse(sessionStorage.getItem("error") || "{}");
    } catch (error) {
        console.error("Error parsing session storage:", error);
        errorDetails = {};
    }

    useEffect(() => {
        if (!errorDetails || Object.keys(errorDetails).length === 0) {
            sessionStorage.removeItem("error");
            window.location.replace("/");
        }

        return () => {
            sessionStorage.removeItem("error");
        };
    }, []);

    const handleGotoLoginPage = () => {
        sessionStorage.removeItem("error");
        window.location.replace("/");
    };

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100vh",
                backgroundColor: "#f5f5f5",
                textAlign: "center",
                padding: 2,
            }}
        >
            <Typography variant="h5" color="error" gutterBottom>
                {errorDetails.message || "Something went wrong"}
            </Typography>
            <Button
                variant="contained"
                onClick={handleGotoLoginPage}
                sx={{
                    padding: "10px 20px",
                    textTransform: "none",
                    backgroundColor: "#023A59",
                    borderRadius: "7px",
                    height: 40,
                    marginTop: 2,
                }}
            >
                Go to Login
            </Button>
        </Box>
    );
};

export default GlobalErrorPage;
